module.exports = __webpack_public_path__ + "img/trash.a360e92e.svg";